import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export default function ExportProductosButton({ data }) {

  const exportar = async () => {

    if (!data || data.length === 0) {
      message.warning("No hay datos para exportar");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Productos");

    // ---------- TITULO ----------
    sheet.mergeCells("A1:J1");

    const title = sheet.getCell("A1");
    title.value = "REPORTE DE PRODUCTOS";
    title.font = { size: 18, bold: true, color: { argb: "FFFFFFFF" } };

    title.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF042956" }
    };

    title.alignment = {
      vertical: "middle",
      horizontal: "center"
    };

    sheet.getRow(1).height = 30;

    // ---------- INFO REPORTE ----------
    sheet.mergeCells("A2:J2");

    const info = sheet.getCell("A2");
    info.value = `Fecha de generación: ${dayjs().format("DD/MM/YYYY HH:mm")}`;
    info.alignment = { horizontal: "center" };

    sheet.addRow([]);

    // ---------- HEADERS ----------
    const headers = [
      "PO",
      "Producto",
      "Tipo",
      "Proveedor",
      "Cantidad",
      "Entregado",
      "Estado inventario",
      "Valor COP",
      "Valor USD",
      "Entrega"
    ];

    const headerRow = sheet.addRow(headers);

    headerRow.eachCell((cell) => {

      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" }
      };

      cell.alignment = {
        vertical: "middle",
        horizontal: "center"
      };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF1F4E78" }
      };

      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };

    });

    // ---------- MAP ESTADOS ----------
    const estadoMap = {
      "finally closed": "Entregado",
      "closed": "Cerrado",
      "open": "Pendiente",
      "pending": "Pendiente"
    };

    // ---------- FILAS ----------
    data.forEach((p) => {

      const estado = estadoMap[p.estado?.toLowerCase()] || p.estado;

      const row = sheet.addRow([
        p.Numero_PO,
        p.nombre_producto,
        p.tipo_producto,
        p.nombre,
        p.stock_disponible || 0,
        p.cantidad_entregada || 0,
        p.estado_stock,
        p.valor_unitario_COP,
        p.valor_unitario_USD,
        p.fecha_estimada_entrega
          ? dayjs(p.fecha_estimada_entrega).format("DD/MM/YYYY")
          : ""
      ]);

      row.eachCell((cell) => {

        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };

        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };

      });

    });

    // ---------- FORMATO MONEDA ----------
    sheet.getColumn(8).numFmt = '"$"#,##0.00';
    sheet.getColumn(9).numFmt = '"$"#,##0.00';

    // ---------- ANCHO COLUMNAS ----------
    sheet.columns = [
      { width: 14 },
      { width: 40 },
      { width: 20 },
      { width: 35 },
      { width: 12 },
      { width: 12 },
      { width: 18 },
      { width: 16 },
      { width: 16 },
      { width: 14 }
    ];

    // ---------- CONGELAR HEADERS ----------
    sheet.views = [
      { state: "frozen", ySplit: 4 }
    ];

    // ---------- DESCARGA ----------
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, `productos_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`);

  };

  return (
    <Button
      icon={<DownloadOutlined />}
      onClick={exportar}
      type="default"
    >
      Exportar
    </Button>
  );
}